export default __webpack_public_path__ + "static/media/Chemistry.bc953d6d.pdf";